/** @file An entity-relative point rounded once to the world grid when the profile snaps (design 21.4). */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import type { View } from '@zilo/pose3d-render-core/camera/viewOf';
import { roundWorld } from '@zilo/pose3d-render-core/place/roundWorld';

/** `round(rel)` on `view.grid` with `snap 'pixel'`, else `rel` (rounding happens before the entity is added). */
export function snapRelOf(rel: Vec3, view: View): Vec3 {
  return view.snap ? roundWorld(rel, view.grid) : rel;
}
